import * as React from 'react';
import { conductCheck } from 'rc-tree/lib/utils/conductUtil';
export default (rawLabeledValues, rawHalfCheckedValues, treeConduction, keyEntities) => React.useMemo(() => {
    let checkedKeys = rawLabeledValues.map(({ value }) => value);
    let halfCheckedKeys = rawHalfCheckedValues.map(({ value }) => value);
    const missingValues = checkedKeys.filter(key => !keyEntities[key]);
    if (treeConduction) {
        ({ checkedKeys, halfCheckedKeys } = conductCheck(checkedKeys, true, keyEntities));
    }
    return [
        // Checked keys should fill with missing keys which should de-duplicated
        Array.from(new Set([...missingValues, ...checkedKeys])),
        // Half checked keys
        halfCheckedKeys
    ];
}, [rawLabeledValues, rawHalfCheckedValues, treeConduction, keyEntities]);
